import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  loading = false;
  resetSent = false;
  emailControl: UntypedFormControl = new UntypedFormControl();

  constructor(private http: HttpClient, private snackbarService: SnackbarService) {}

  resetPage(): void {
    this.resetSent = false;
    this.loading = false;
  }

  submitResetRequest(): void {
    if (this.emailControl.errors || this.loading) {
      return;
    }
    this.loading = true;
    this.sendRequestEmail();
  }

  sendRequestEmail(): any {
    return this.http
      .post('/_ajax/v1/user-forgot-password/', `email=${this.emailControl.value}`, {
        headers: new HttpHeaders({
          'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        }),
      })
      .pipe(
        take(1),
        catchError(() => {
          this.loading = false;
          this.snackbarService.openWithOptions('FORGOT_PASSWORD.CHECK_EMAIL.NOT_SENT');
          return of(null);
        }),
      )
      .subscribe((value) => {
        if (value) {
          this.resetSent = true;
        }
      });
  }
}
